
<template>
    <v-form v-model="isValid">
        <vertical-form-table v-model="form" v-bind="{ items }">
            <template slot="문의종류">
                <v-select v-model="form.meta.type" :items="types" outlined />
            </template>
        </vertical-form-table>

        <terms-of-agreements-short v-model="form.meta._terms" @isValid="(isValid) => (isTermsValid = isValid)" />

        <div class="v-btn-group">
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" :disabled="!isValid" @click="save"><span>문의하기</span></v-btn>
        </div>
    </v-form>
</template>

<script>
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import TermsOfAgreementsShort from "@/components/client/join/terms-of-agreements-short.vue";
import api from "@/api";

const code = "service-inquiry";

const types = ["문의종류1", "문의종류2"];

const intiForm = () => ({
    code,
    meta: {
        _terms: [],
        companyName: null,
        name: null,
        phone: null,
        email: null,
        type: null,
    },
    subject: null,
    content: null,
});

const items = [
    {
        key: "meta.companyName",
        term: "회사명",
        type: "text",
        required: true,
        rules: [(value) => !!value || "회사명을 입력해주세요"],
    },
    {
        key: "meta.name",
        term: "담당자명",
        type: "text",
    },
    {
        key: "meta.phone",
        term: "연락처",
        type: "phone",
        required: true,
    },
    {
        key: "meta.email",
        term: "이메일",
        type: "email",
        required: true,
        rules: [(value) => !!value || "이메일을 입력해주세요"],
    },
    // {
    //     key: "meta.type",
    //     term: "문의종류",
    //     required: true,
    // },
    {
        key: "subject",
        term: "제목",
        type: "text",
        required: true,
        placeholder: "제목을 입력하세요.",
        rules: [(value) => !!value || "제목을 입력해주세요"],
    },
    {
        key: "content",
        term: "내용",
        type: "textarea",
        required: true,
        placeholder: "내용을 입력하세요.",
        rules: [(value) => !!value || "내용을 입력해주세요"],
    },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        VerticalFormTable,
        TermsOfAgreementsShort,
    },
    data: () => ({
        form: intiForm(),

        loading: false,
        isValid: undefined,
        isTermsValid: undefined,

        items,
        types,
    }),
    methods: {
        validates() {
            try {
                if (!this.form.meta.companyName) throw new Error("회사명을 입력해주세요");
                if (!this.form.meta.phone) throw new Error("연락처를 입력해주세요");
                if (!this.form.meta.email) throw new Error("이메일을 입력해주세요");
                if (!this.form.subject) throw new Error("제목을 입력해주세요");
                if (!this.form.content) throw new Error("내용을 입력해주세요");
            } catch (error) {
                alert(error.message);
                return false;
            }
            return true;
        },
        async save() {
            if (!this.validates()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.forms.post(this.form);
            } finally {
                this.loading = false;
                alert("문의가 작성되었습니다");
                this.$router.go(-1);
            }
        },
    },
};
</script>
